import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ClientPageRequest } from '../model/management-config/clientPageRequest';
import { CreateClientsRequest, UpdateClientsRequest } from '../model/management-config/clientManagement';


@Injectable({
  providedIn: 'root'
})
export class ClientManagementService{

  private baseUrl: string;
  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiUrl;
  }

  public getClientList(request: ClientPageRequest): Observable<any> {
    console.log("Get all Client Management list..");
    const  headers = new  HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post<ClientPageRequest>(this.baseUrl.concat("/clients"), request, {headers: headers});
  }

  public addClientRequests(client:CreateClientsRequest): Observable<any> {
    console.log("save Clients Data :: Saving data..");
    console.log(client);
    const headers = new HttpHeaders()
     .set('Content-Type', 'application/json');
    return this.http.post<CreateClientsRequest>(this.baseUrl.concat("/clients/create"), client, { headers: headers });
  }

  public editClientRequests(client:UpdateClientsRequest): Observable<any> {
    console.log("Edit Clients Data :: Saving data..");
    console.log(client);
    const headers = new HttpHeaders()
     .set('Content-Type', 'application/json');
    return this.http.post<UpdateClientsRequest>(this.baseUrl.concat("/clients/update"), client, { headers: headers });
  }

}
